<template>
    <div
        class="mobile_donation_button hide-from-print"
        :class="{ closed: isClosed }"
    >
        <div class="donation box_shadow">
            <a
                href="https://donate.cancer.org.il/"
                target="_blank"
                rel="noopener noreferrer"
                class="btn btn_red"
            >
                {{ $t('header.donateButton') }}
            </a>
            <button
                class="btn_close btn_reset"
                type="button"
                :aria-label="$t('general.close')"
                @click="isClosed = true"
            />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isClosed: false
        };
    }
};
</script>
